import numeral from 'numeral'
import type { ChangeEvent } from 'react'
import React, { useEffect, useRef, useState } from 'react'

import type { IFormKitControlProps } from 'components/formKit/types'
import { IconButton } from 'components/uiKit/Button'
import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import { t } from 'services/Translation'

import * as s from './FieldUploadMetadata.module.scss'

const FieldUploadMetadata: React.FC<IFormKitControlProps<string | null>> = ({
  value,
  onChange,
  name,
}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [selectedFile, setSelectedFile] = useState<File | null>(null)

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null
    setSelectedFile(file)
  }

  const handleFileRemove: React.MouseEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault()
    setSelectedFile(null)
    if (inputRef.current) {
      inputRef.current.value = ''
    }
  }

  useEffect(() => {
    if (selectedFile) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const text = e.target?.result
        if (text && text !== value) {
          onChange({ name, value: text.toString() })
        }
      }
      reader.readAsText(selectedFile)
    }

    if (selectedFile === null && value !== null) {
      onChange({ name, value: null })
    }
  }, [name, onChange, selectedFile, value])

  return (
    <div className={s.root}>
      <label className={s.container}>
        <input
          accept='.xml'
          onChange={handleFileChange}
          ref={inputRef}
          style={{ display: 'none' }}
          type='file'
        />
        <Icon name='otherDownload' size={KitSize.S} />
        {selectedFile ? (
          <div className={s.file}>
            {selectedFile.name}
            <span className={s.size}>{numeral(selectedFile.size).format('0.0 b')}</span>
          </div>
        ) : (
          t('entity.sso.uploadXML')
        )}
        {selectedFile && (
          <div className={s.icon} onClick={handleFileRemove}>
            <IconButton icon='otherClose' name='remofeFile' size={KitSize.S} styleType='ghost' />
          </div>
        )}
      </label>
    </div>
  )
}

export default React.memo(FieldUploadMetadata) as typeof FieldUploadMetadata
